(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const infoButton = document.querySelector('.cart__info-button');
    const tooltip = document.querySelector('.cart__info-tooltip');
    let tooltipTimeout;
    
    if (infoButton && tooltip) {
      infoButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Toggle active class
        infoButton.classList.toggle('active');
        
        // Clear existing timeout
        if (tooltipTimeout) {
          clearTimeout(tooltipTimeout);
        }
        
        // Set new timeout to close after 2.5 seconds if tooltip is active
        if (infoButton.classList.contains('active')) {
          tooltipTimeout = setTimeout(function() {
            infoButton.classList.remove('active');
          }, 3500);
        }
      });

      // Schließe Tooltip beim Klick außerhalb
      document.addEventListener('click', function(e) {
        if (!infoButton.contains(e.target) && !tooltip.contains(e.target)) {
          infoButton.classList.remove('active');
          if (tooltipTimeout) {
            clearTimeout(tooltipTimeout);
          }
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // Finde alle Info-Buttons
    const infoButtons = document.querySelectorAll('[data-modal-trigger]');
    
    infoButtons.forEach(function(button) {
      const modalId = button.getAttribute('data-modal-trigger');
      const modalOverlay = document.querySelector('[data-modal-id="' + modalId + '"]');
      
      if (modalOverlay) {
        const modalClose = modalOverlay.querySelector('[data-modal-close]');
        
        // Open modal on button click
        button.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          modalOverlay.classList.add('active');
          document.body.classList.add('modal-open');
        });

        // Close modal on close button click
        if (modalClose) {
          modalClose.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            modalOverlay.classList.remove('active');
            document.body.classList.remove('modal-open');
          });
        }

        // Close modal when clicking on overlay background
        modalOverlay.addEventListener('click', function(e) {
          if (e.target === modalOverlay) {
            modalOverlay.classList.remove('active');
            document.body.classList.remove('modal-open');
          }
        });

        // Close modal on ESC key
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
            modalOverlay.classList.remove('active');
            document.body.classList.remove('modal-open');
          }
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
